/* quick-view-modal.js
   --------------------
   Opens a quick-view modal for products with multiple variants when
   their "add to cart" button is clicked on a collection page.
*/

(function () {
  'use strict';

  var overlay = document.getElementById('QuickViewOverlay');
  var modal = document.getElementById('QuickViewModal');
  var content = document.getElementById('QuickViewContent');
  var closeBtn = document.getElementById('QuickViewCloseBtn');

  if (!overlay || !modal || !content) return;

  var cache = {}; // handle -> html string
  var isOpen = false;
  var touchStartY = null;
  var currentTranslateY = 0;

  function getHeaderHeight() {
    // Try common header selectors used by this theme; fall back to 0
    // if none are found, so the modal just centers normally.
    var header = document.getElementById('SiteHeader') ||
      document.querySelector('.header-wrapper') ||
      document.querySelector('#shopify-section-header') ||
      document.querySelector('header');
    if (!header) return 0;
    return header.getBoundingClientRect().bottom;
  }

  function positionModalBelowHeader() {
    if (window.innerWidth < 750) {
      // Mobile uses the bottom-sheet CSS (fixed left/right/bottom in
      // the stylesheet). Clear any inline desktop positioning left
      // over from before the viewport crossed the breakpoint -
      // without this, resizing a desktop-positioned open modal down
      // to mobile width left stale inline top/left/transform values
      // fighting the mobile CSS, so the modal looked stuck or broken
      // until a full page reload reset everything from scratch.
      modal.style.top = '';
      modal.style.left = '';
      modal.style.transform = '';
      return;
    }
    var headerBottom = Math.max(getHeaderHeight(), 0);
    var viewportHeight = window.innerHeight;
    var modalHeight = modal.offsetHeight || viewportHeight * 0.74;
    var availableHeight = viewportHeight - headerBottom;
    // Center the modal in the space below the header, but never let
    // it go above the header or below the viewport bottom.
    var top = headerBottom + Math.max((availableHeight - modalHeight) / 2, 12);
    modal.style.top = top + 'px';
    modal.style.left = '50%';
    modal.style.transform = 'translateX(-50%)';
  }

  function openModal() {
    overlay.hidden = false;
    modal.hidden = false;
    document.body.classList.add('qv-lock-scroll');
    positionModalBelowHeader();
    requestAnimationFrame(function () {
      positionModalBelowHeader();
      overlay.classList.add('is-visible');
      modal.classList.add('is-open');
    });
    isOpen = true;
    document.addEventListener('keydown', onKeydown);
    window.addEventListener('resize', positionModalBelowHeader);
  }

  function closeModal() {
    overlay.classList.remove('is-visible');
    modal.classList.remove('is-open');
    document.body.classList.remove('qv-lock-scroll');
    isOpen = false;
    document.removeEventListener('keydown', onKeydown);
    window.removeEventListener('resize', positionModalBelowHeader);
    setTimeout(function () {
      overlay.hidden = true;
      modal.hidden = true;
      content.innerHTML = '';
    }, 250);
  }

  function onKeydown(evt) {
    if (evt.key === 'Escape' || evt.keyCode === 27) closeModal();
  }

  overlay.addEventListener('click', closeModal);
  if (closeBtn) closeBtn.addEventListener('click', closeModal);

  var dragHandle = modal.querySelector('.qv-modal__drag-handle');
  function attachSwipeClose(el) {
    if (!el) return;
    el.addEventListener('touchstart', function (e) {
      touchStartY = e.touches[0].clientY;
      modal.style.transition = 'none';
    }, { passive: true });
    el.addEventListener('touchmove', function (e) {
      if (touchStartY === null) return;
      var dy = e.touches[0].clientY - touchStartY;
      if (dy > 0) {
        currentTranslateY = dy;
        modal.style.transform = 'translateY(' + dy + 'px)';
      }
    }, { passive: true });
    el.addEventListener('touchend', function () {
      modal.style.transition = '';
      modal.style.transform = '';
      if (currentTranslateY > 100) {
        closeModal();
      }
      touchStartY = null;
      currentTranslateY = 0;
    });
  }
  attachSwipeClose(dragHandle);

  function fetchQuickView(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    if (cache[handle + ':pending']) return cache[handle + ':pending'];
    var url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') +
      'products/' + handle + '?view=quick-view';
    url = url.replace('//', '/');
    var p = fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        cache[handle] = html;
        delete cache[handle + ':pending'];
        return html;
      });
    cache[handle + ':pending'] = p;
    return p;
  }

  // Prefetch quick-view HTML for any trigger that scrolls into view,
  // AND on hover/touchstart as a fallback. This makes the modal feel
  // instant on both desktop (hover) and mobile (visible-on-screen),
  // since fetching only starts once the click happens otherwise.
  var prefetchObserver = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var handle = entry.target.getAttribute('data-product-handle');
            if (handle) fetchQuickView(handle);
            prefetchObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px 0px' })
    : null;

  function prefetchTriggers(scope) {
    var root = scope || document;
    root.querySelectorAll('.js-quick-view-trigger:not([data-qv-prefetch])').forEach(function (btn) {
      btn.setAttribute('data-qv-prefetch', 'true');
      var handle = btn.getAttribute('data-product-handle');
      if (!handle) return;

      if (prefetchObserver) {
        prefetchObserver.observe(btn);
      }

      var card = btn.closest('.card-wrapper, .grid-product') || btn;
      card.addEventListener('mouseenter', function () { fetchQuickView(handle); }, { once: true });
    });
  }

  function initGallery(root) {
    var thumbs = root.querySelectorAll('.qv__thumb');
    var slides = root.querySelectorAll('.qv__gallery-slide');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mediaId = thumb.getAttribute('data-media-id');
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        slides.forEach(function (s) { s.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var targetSlide = root.querySelector('.qv__gallery-slide[data-media-id="' + mediaId + '"]');
        if (targetSlide) targetSlide.classList.add('is-active');
      });
    });

    // On products with many shades (dozens of thumbnails), the
    // browser can lock in a stale, too-small scrollWidth for the
    // thumbnail strip right after the markup is injected, before
    // every thumbnail has settled into its final flex layout - the
    // strip then can't be scrolled far enough to reach the last
    // several thumbnails even though they're all present in the DOM.
    // Forcing a synchronous reflow read (offsetWidth) after layout
    // has a moment to settle fixes this without any visible delay.
    var thumbsContainer = root.querySelector('.qv__gallery-thumbs');
    if (thumbsContainer) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          void thumbsContainer.offsetWidth; // force reflow
        });
      });
    }
  }

  function showMediaForVariant(root, variant) {
    if (!variant || !variant.featured_media) return;
    var mediaId = variant.featured_media.id;
    var slide = root.querySelector('.qv__gallery-slide[data-media-id="' + mediaId + '"]');
    var thumb = root.querySelector('.qv__thumb[data-media-id="' + mediaId + '"]');
    if (slide) {
      root.querySelectorAll('.qv__gallery-slide').forEach(function (s) { s.classList.remove('is-active'); });
      slide.classList.add('is-active');
    }
    if (thumb) {
      root.querySelectorAll('.qv__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      // Scroll the thumbnail strip so the newly-active thumbnail is
      // actually visible. Deliberately NOT using scrollIntoView here:
      // it behaves inconsistently in RTL/mixed-direction containers
      // across browsers and was observed scrolling the entire strip
      // completely out of view (thumbnails ending up at negative or
      // far-off-screen x positions) instead of centering the target.
      // Computing scrollLeft manually avoids that.
      var container = thumb.closest('.qv__gallery-thumbs');
      if (container) {
        var containerRect = container.getBoundingClientRect();
        var thumbRect = thumb.getBoundingClientRect();
        var thumbOffsetWithinContainer = (thumbRect.left - containerRect.left) + container.scrollLeft;
        var targetScrollLeft = thumbOffsetWithinContainer - (container.clientWidth / 2) + (thumbRect.width / 2);
        container.scrollTo({ left: targetScrollLeft, behavior: 'smooth' });
      }
    }
  }

  function initQuantity(root) {
    var wrapper = root.querySelector('#QvQuantity');
    if (!wrapper) return;
    var input = wrapper.querySelector('#QvQuantityValue');
    var minusBtn = wrapper.querySelector('[data-qv-qty-minus]');
    var plusBtn = wrapper.querySelector('[data-qv-qty-plus]');

    function getVal() {
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      return v;
    }
    function setVal(v) {
      if (v < 1) v = 1;
      input.value = v;
      minusBtn.classList.toggle('disabled', v <= 1);
    }

    minusBtn.addEventListener('click', function () { setVal(getVal() - 1); });
    plusBtn.addEventListener('click', function () { setVal(getVal() + 1); });
    input.addEventListener('change', function () { setVal(getVal()); });
    setVal(getVal());
  }

  function getQuantity(root) {
    var input = root.querySelector('#QvQuantityValue');
    var v = input ? parseInt(input.value, 10) : 1;
    if (isNaN(v) || v < 1) v = 1;
    return v;
  }

  function initVariantPicker(root, productId) {
    var variantDataEl = root.querySelector('#QvVariantData-' + productId);
    if (!variantDataEl) return;
    var variants;
    try {
      variants = JSON.parse(variantDataEl.textContent);
    } catch (e) {
      return;
    }

    var optionEls = root.querySelectorAll('.qv__option');
    var addBtn = root.querySelector('#QvAddToCart');
    var priceEl = root.querySelector('#QvPrice');
    var inventoryEl = root.querySelector('#QvInventory');
    var inventoryTextEl = inventoryEl ? inventoryEl.querySelector('.qv__inventory-text') : null;

    function getSelectedOptions() {
      var selected = [];
      optionEls.forEach(function (optEl, idx) {
        var activeBtn = optEl.querySelector('.qv__swatch.is-selected, .qv__pill.is-selected');
        selected[idx] = activeBtn ? activeBtn.getAttribute('data-value') : null;
      });
      return selected;
    }

    function findVariant(selected) {
      return variants.find(function (v) {
        return selected.every(function (val, i) {
          return val === null || v['option' + (i + 1)] === val;
        });
      });
    }

    function formatMoney(cents) {
      if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
        return window.theme.Currency.formatMoney(cents, window.theme.settings && window.theme.settings.moneyFormat);
      }
      return '₪' + (cents / 100).toFixed(2);
    }

    function updateUI(variant) {
      if (!variant) return;
      addBtn.setAttribute('data-variant-id', variant.id);
      if (variant.available) {
        addBtn.removeAttribute('disabled');
        // Hard-coded Hebrew text - deliberately NOT falling back to
        // window.variantStrings/window.theme.strings, since those
        // exist on this theme but hold ENGLISH text ("Add to cart",
        // "In stock" etc), which is why the label used to flip to
        // English every time a variant was switched.
        addBtn.querySelector('.qv__add-to-cart-text').textContent = 'הוספה לסל';
        if (inventoryEl) {
          inventoryEl.classList.remove('is-soldout');
          if (inventoryTextEl) inventoryTextEl.textContent = 'במלאי, מוכן לאספקה מיידית :)';
        }
      } else {
        addBtn.setAttribute('disabled', 'disabled');
        addBtn.querySelector('.qv__add-to-cart-text').textContent = 'אזל מהמלאי';
        if (inventoryEl) {
          inventoryEl.classList.add('is-soldout');
          if (inventoryTextEl) inventoryTextEl.textContent = 'אזל מהמלאי';
        }
      }
      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML = '<s class="qv__compare-price">' + formatMoney(variant.compare_at_price) + '</s>' +
            '<span class="qv__sale-price">' + formatMoney(variant.price) + '</span>';
        } else {
          priceEl.innerHTML = '<span class="qv__regular-price">' + formatMoney(variant.price) + '</span>';
        }
      }
      showMediaForVariant(root, variant);
    }

    optionEls.forEach(function (optEl) {
      optEl.querySelectorAll('.qv__swatch, .qv__pill').forEach(function (btn) {
        btn.addEventListener('click', function () {
          // Sold-out shades are still clickable, same as the real
          // product page: the customer can select one to see its
          // photo, and the add-to-cart button/inventory text below
          // update to reflect that it's unavailable (disabled,
          // "sold out" label) via updateUI() - it's just not
          // purchasable, not unselectable.
          optEl.querySelectorAll('.qv__swatch, .qv__pill').forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          var valueLabel = optEl.querySelector('[data-option-selected-value]');
          if (valueLabel) valueLabel.textContent = btn.getAttribute('data-value');

          var selected = getSelectedOptions();
          var variant = findVariant(selected);
          updateUI(variant);
        });
      });
    });
  }

  function initAddToCart(root) {
    var addBtn = root.querySelector('#QvAddToCart');
    if (!addBtn) return;
    addBtn.addEventListener('click', function () {
      if (addBtn.hasAttribute('disabled') || addBtn.classList.contains('is-loading')) return;
      var variantId = addBtn.getAttribute('data-variant-id');
      if (!variantId) return;
      var quantity = getQuantity(root);

      addBtn.classList.add('is-loading');

      fetch((window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          addBtn.classList.remove('is-loading');
          if (data.status === 422 || data.status === 'bad_request') {
            var text = addBtn.querySelector('.qv__add-to-cart-text');
            if (text) text.textContent = data.description || 'שגיאה';
            return;
          }
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data, addToCartBtn: addBtn } }));
          closeModal();
          document.dispatchEvent(new CustomEvent('cart:open'));
        })
        .catch(function () {
          addBtn.classList.remove('is-loading');
        });
    });
  }

  function openQuickView(handle) {
    openModal();
    content.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;min-height:200px;"></div>';

    fetchQuickView(handle).then(function (html) {
      if (!isOpen) return;
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var qvRoot = doc.querySelector('.qv');
      if (!qvRoot) {
        content.innerHTML = '<p class="qv__error">לא ניתן היה לטעון את המוצר.</p>';
        return;
      }
      content.innerHTML = '';
      content.appendChild(qvRoot);

      var closeInModal = qvRoot.querySelector('.qv__close');
      if (closeInModal) closeInModal.addEventListener('click', closeModal);

      var productId = qvRoot.getAttribute('data-product-id');
      initGallery(qvRoot);
      initVariantPicker(qvRoot, productId);
      initQuantity(qvRoot);
      initAddToCart(qvRoot);
      positionModalBelowHeader();
    }).catch(function () {
      content.innerHTML = '<p class="qv__error">לא ניתן היה לטעון את המוצר.</p>';
    });
  }

  function bindTriggers(scope) {
    var root = scope || document;
    prefetchTriggers(root);
    root.querySelectorAll('.js-quick-view-trigger:not([data-qv-bound])').forEach(function (btn) {
      btn.setAttribute('data-qv-bound', 'true');
      btn.addEventListener('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        var handle = btn.getAttribute('data-product-handle');
        if (!handle) return;
        openQuickView(handle);
      });
    });
  }

  bindTriggers();

  document.addEventListener('collection:reloaded', function () { bindTriggers(); });
  document.addEventListener('recommendations:loaded', function (evt) {
    bindTriggers(evt.detail && evt.detail.section ? evt.detail.section : document);
  });

  // The product grid can grow after initial page load: infinite
  // scroll (Ajaxinate), lazy-loaded cards entering the viewport, or
  // any other mechanism that appends new <li> product cards to
  // #product-grid without firing collection:reloaded. Without this,
  // bindTriggers() only ever saw whatever handful of cards existed
  // in the DOM at page-load time, and every card appended afterward
  // silently never got its click listener attached.
  var productGrid = document.getElementById('product-grid');
  if (productGrid && 'MutationObserver' in window) {
    var gridObserver = new MutationObserver(function (mutations) {
      var hasNewNodes = mutations.some(function (m) { return m.addedNodes && m.addedNodes.length > 0; });
      if (hasNewNodes) bindTriggers();
    });
    gridObserver.observe(productGrid, { childList: true, subtree: true });
  }

  // Fallback safety net: some lazy-load mechanisms replace innerHTML
  // in ways a scoped MutationObserver might miss (e.g. a different
  // container swapped in entirely). Periodically re-scan the whole
  // document for any trigger that still isn't bound. Cheap since
  // bindTriggers() itself is a no-op for already-bound elements.
  var rescanInterval = setInterval(function () {
    if (document.querySelector('.js-quick-view-trigger:not([data-qv-bound])')) {
      bindTriggers();
    }
  }, 1000);
})();
